/* Este componente é responsável por exibir um carrossel de artigos relacionados à doutrina espírita. 
Componente faz a chamada para a API para obter os artigos e exibi-los em um formato de carrossel, permitindo que os usuários naveguem pelos artigos de forma fácil e intuitiva.
*/

import { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { Link } from 'react-router-dom';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './CarouselArtigos.css';


const CarouselArtigos = () => {

const [artigos, setArtigos] = useState([]);

    
// O useEffect é usado para buscar os artigos da API quando o componente é montado. Ele faz uma requisição para a rota '/api/artigo-carousel' e, se a resposta for bem-sucedida, os dados dos artigos são salvos no estado do componente usando setArtigos. Se houver um erro durante a requisição, ele é capturado e exibido no console.   
useEffect(() => {
    const buscarArtigos = async () => {
        try {

            const url = `${process.env.REACT_APP_API_URL}/artigo-carousel`;
            //Nesta requisição, o método é GET, e os headers incluem 'Content-Type': 'application/json', indicando que o conteúdo da requisição é do tipo JSON. O backend deve estar configurado para aceitar essa requisição e retornar os dados dos artigos em formato JSON. Nesta chamada não precisamos de autenticação, pois o carrossel de artigos é público e acessível a todos os usuários, sem a necessidade de login ou permissões especiais. O backend deve estar configurado para permitir o acesso a essa rota sem exigir autenticação, garantindo que os dados dos artigos possam ser acessados por qualquer usuário, independentemente de seu status de autenticação.
            const resposta  = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',   
                }
            });
            
            if (!resposta.ok) {
                    // Se o backend retornar 401 ou 403, algo está errado com a permissão
                    throw new Error(`Erro na requisição: ${resposta.status}`);
                }
            
            // Se a resposta for bem-sucedida, processa os dados retornados. O backend deve retornar um JSON com uma estrutura que inclui um campo 'status' indicando o sucesso da operação e um campo 'dados' contendo os artigos. O código verifica se o status é 'sucesso' e, em caso afirmativo, salva os artigos no estado do componente usando setArtigos. Isso garante que os dados dos artigos estejam disponíveis para renderização e outras operações dentro do componente.
            const dadosRetorno = await resposta.json();
        
            if (dadosRetorno.status === 'sucesso') {
            //Se tiver sucesso, salva os artigos no estado para que os dados originalmente recebidos do backend estejam disponíveis para renderização e outras operações. Caso contrário, o estado de artigos permanecerá vazio, e o componente pode lidar com isso adequadamente (por exemplo, exibindo uma mensagem de erro ou um estado de carregamento).
            setArtigos(dadosRetorno.dados); // Salva os artigos no estado para que os dados originalmente recebidos do backend estejam disponíveis para renderização e outras operações
            console.log('Artigos recebidos do backend:', dadosRetorno.dados); // Log para verificar os dados recebidos
            }       
        } catch (error) {
            console.error('Erro ao buscar artigos:', error);
        }
    }
    buscarArtigos();
}, []);


  return (
    <div className="container-fluid">
        
        {artigos.length > 0 && (
            <h2 className="carousel__titulo">Artigos Recentes</h2>
        )}
        
        <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            spaceBetween={30}
            slidesPerView={1}
            navigation
            pagination={{ clickable: true }}
            autoplay={{ delay: 3000 }}
        >
            {artigos.map(artigo => (
                <SwiperSlide key={artigo.uuid}>
                    <div className="carousel__item--custom">
                        <img src={`${process.env.REACT_APP_API_URL}/public/assets/imagens/artigos/${artigo.arquivo}`} alt={artigo.titulo} />
                        <Link 
                            to={`/ver-artigo/${artigo.uuid}`}
                            className="carousel__titulo--link">
                            {artigo.titulo}
                        </Link>
                        <p className="carousel__texto">Por: {artigo.nome}</p>
                    </div>
                </SwiperSlide>
            ))}
        </Swiper>
    </div>
  );
}

export default CarouselArtigos;